import React, { useState } from 'react';
import PropTypes from 'prop-types';
import notifyAnalytics from '../notify-analytics';
import styles from './DesktopMenuItem.scss';

const TouchMenuItem = ({ label, url, children }) => {
  const [active, setActive] = useState(false);

  const handleOnClick = () => {
    setActive(currentlyActive => !currentlyActive);
  };

  const onClose = () => {
    if (active) setActive(false);
  };

  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { onClose });
    }
    return child;
  });

  return (
    <li className={styles.desktopMenuItem} data-active={active}>
      {url && !children && (
        <a
          className={styles.desktopMenuItemLink}
          href={url}
          onClick={() => notifyAnalytics(label)}
        >
          {label}
        </a>
      )}
      {children && (
        <>
          <button
            className={styles.touchMenuItemButton}
            onClick={handleOnClick}
            onMouseLeave={() => setActive(false)}
          >
            {label}
          </button>
          {active && childrenWithProps}
        </>
      )}
    </li>
  );
};

TouchMenuItem.defaultProps = {
  url: '',
  children: undefined,
};

TouchMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string,
  children: PropTypes.node,
};

export default TouchMenuItem;
